export default __webpack_public_path__ + "static/media/linkIcon-dark.529333ab.svg";